import { DeliverySupportCookies } from './storage/deliverySupport'

export const isPostalCodeAdded = (token?: string) => {
  const addressCookies = DeliverySupportCookies.get()

  const savedPostalCode = addressCookies.postalCode || null
  const savedCity = addressCookies.city || null
  const isPostalCodeAndCitySupported = addressCookies.isSupported || false

  return token || (savedPostalCode && savedCity && isPostalCodeAndCitySupported)
}
